import {
  UPDATE_EMAIL_NOTIFICATIONS,
} from '../../types';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  updateEmailNotification,
  updateEmailNotificationPending,
  updateEmailNotificationFulfilled,
  updateEmailNotificationRejected,
} = createAsyncActions(UPDATE_EMAIL_NOTIFICATIONS, 'updateEmailNotification');



// WEBPACK FOOTER //
// ./src/features/organization/actions/updateActions/updateEmailNotificationActions.js